import styled from 'styled-components';

import { black } from 'styles/colors';
import { fromLarge } from 'styleUtils/mediaQueries';

export const Section = styled.section`
    display: flex;
    justify-content: center;
    text-align: justify;
    color: ${black};
    padding: 1.5rem 0;

    ${fromLarge`
        padding: 50px 0;
    `}

    h2 {
        margin-bottom: 1.5rem;
    }
    h5 {
        margin-bottom: 1rem;
    }
    p {
        margin-bottom: 2rem;
    }
    ul {
        margin-left: 25px;
        margin-bottom: 2rem;
        margin-top: -1rem;
        li {
            p {
                margin: 0;
            }
        }
    }
`;
